var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","color":"g-cc"},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("arrow_back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }